/* eslint-disable no-constant-condition */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-useless-concat */
/* eslint-disable prefer-destructuring */
// Disabled above lint because anyways this fill will not be needed eventually
/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ConfigDeviceSettings from '../../config/device.config';
import bnd3Service from '../../services/bnd3.service';
import utilityService from '../../services/utility.service';
import ChartConst from '../../constants/chart.constant';
import AppConst from '../../constants/app.constant';
import DefConst from '../../constants/def.constant';
import bnChartDataProcessService from '../../services/chartDataProcess.service';
import d3 from '../../globalexports/d3.export';
import { getTempLabelValue } from '../../services/chartData/getTempLabelValue';

function mapLeafService() {
  const content = {};
  let dateFormat;
  let settingsObj;

  function setDateFormat() {
    if (settingsObj.timeZone === AppConst.timeZones.local.key) {
      dateFormat = d3.timeFormat(
        ChartConst.xAxis.formatLocal + ChartConst.GraphConfig.xAxis.timePostFix.local,
      );
    } else {
      dateFormat = d3.utcFormat(
        ChartConst.xAxis.format + ChartConst.GraphConfig.xAxis.timePostFix.zulu,
      );
    }
  }

  function getFormatText(dMain, key, constRefKey) {
    const versionToUse = ConfigDeviceSettings.settings.apiVersionKey;
    const d = ChartConst.ChartLabelSpecs[constRefKey || key];
    let formattedText = `${d.tooltip.prefix}: `;
    let toWhatDecimal;

    if (key === 'cig_mapped') {
      console.log(formattedText);
      // debugger
    }
    if (dMain.isUsingLamp === true) {
      // in mav for first 24hrs
      // p06 is treated as ppo of LAMP and
      // t06 is treated as t01 of LAMP
      if (d.key === ChartConst.ChartLabelSpecs.p06.key) {
        formattedText = `${ChartConst.ChartLabelSpecs.ppo.tooltip.prefix}: `;
      }
      if (d.key === ChartConst.ChartLabelSpecs.t06.key) {
        formattedText = `${ChartConst.ChartLabelSpecs.t01.tooltip.prefix}: `;
      }
    }
    toWhatDecimal = d.key === ChartConst.ChartLabelSpecs.q06.key ? 1 : 0;
    if (key === 'alt') {
      toWhatDecimal = 2;
    }
    if (key === 'wsp' && dMain.wsp >= 1) {
      formattedText += `${
        dMain.wdr === 0
          ? `${ChartConst.variableWind} `
          : `00${dMain.wdr * 10}`.slice(-3) + ChartConst.ChartLabelSpecs.wdr.tooltip.unit
      } `;
    }
    if (
      versionToUse !== 3
      && !dMain.isMetarObj
      && dMain[key]
      && d.key === ChartConst.ChartLabelSpecs.cig.key
    ) {
      if (dMain[key] >= ChartConst.lastCigValue) {
        formattedText += ChartConst.greaterThan;
      } else if (dMain[key] <= ChartConst.firstCigValue) {
        formattedText += ChartConst.lessThan;
      }
    }
    if (versionToUse !== 3 && d.key === ChartConst.ChartLabelSpecs.cig.key) {
      if (dMain[key] !== null && !dMain.isMetarObj && dMain[key] <= ChartConst.firstCigValue) {
        formattedText += ChartConst.cigMinThresholdTooltip;
      } else if (
        dMain[key] !== null
        && !dMain.isMetarObj
        && d.key === ChartConst.ChartLabelSpecs.cig.key
      ) {
        formattedText += utilityService.roundCeilings(dMain.tooltipValue).toFixed(toWhatDecimal);
      } else if (dMain[key] !== null) {
        formattedText
          += (dMain.vert_vis_ft >= 0 ? `${DefConst.Obscured} ` : '')
          + dMain[key].toFixed(toWhatDecimal);
      } else {
        formattedText += ChartConst.GraphConfig.noDataText;
      }
    } else if (d.key === ChartConst.ChartLabelSpecs.wsp.key && dMain[key] < 1) {
      formattedText += ChartConst.calmWind;
    } else if (
      versionToUse !== 3
      && d.key === ChartConst.ChartLabelSpecs.vis.key
      && !dMain.isMetarObj
      && (dMain[key] === ChartConst.firstVis || dMain[key] === ChartConst.lastVis)
    ) {
      if (dMain[key] === ChartConst.lastVis) {
        formattedText += ChartConst.greaterThan + ChartConst.visMaxThresholdTooltip;
      } else if (dMain[key] === ChartConst.firstVis) {
        formattedText += ChartConst.lessThan + ChartConst.visMinThresholdTooltip;
      }
    } else if (d.key === ChartConst.ChartLabelSpecs.vis.key && dMain.isMetarObj) {
      formattedText += dMain[key];
    } else if (
      d.key === ChartConst.ChartLabelSpecs.p06.key
      || d.key === ChartConst.ChartLabelSpecs.ppo.key
      || d.key === ChartConst.ChartLabelSpecs.t06.key
      || d.key === ChartConst.ChartLabelSpecs.t01.key
      || d.key === ChartConst.ChartLabelSpecs.st6.key
      || d.key === ChartConst.ChartLabelSpecs.sno.key
      || d.key === ChartConst.ChartLabelSpecs.cp2.key
      || d.key === ChartConst.ChartLabelSpecs.fzp.key
    ) {
      formattedText
        += dMain[key] !== null
          ? dMain[key]
            < (d.key === ChartConst.ChartLabelSpecs.st6.key
              ? ChartConst.st6MinThresholdTooltip
              : ChartConst.precipMinThresholdTooltip)
            ? ChartConst.noneTooltip
            : dMain[key].toFixed(toWhatDecimal)
          : ChartConst.GraphConfig.noDataText;
    } else if (d.key === ChartConst.ChartLabelSpecs.tmp.key) {
      formattedText += getTempLabelValue(
        settingsObj.temperatureUnit,
        dMain.tmp_celsius,
        dMain.tmp_fahrenheit,
      );
    } else {
      formattedText
        += dMain[key] !== null
          ? dMain[key].toFixed(toWhatDecimal) === '-0'
            ? '0'
            : dMain[key].toFixed(toWhatDecimal)
          : ChartConst.GraphConfig.noDataText;
    }
    if (d.key === ChartConst.ChartLabelSpecs.dew.key
    ) {
      // For temperature use units based on user setting preferences
      formattedText += `${
        dMain[key] !== null ? `${d.tooltip.unit} ${settingsObj.temperatureUnit}` : ''
      } `;
    } else if (
      (d.key === ChartConst.ChartLabelSpecs.wsp.key && dMain[key] < 1)
      || (d.key === ChartConst.ChartLabelSpecs.vis.key && dMain.isMetarObj)
    ) {
      formattedText += '';
    } else if (d.key !== ChartConst.ChartLabelSpecs.tmp.key) {
      formattedText += `${
        dMain[key] !== null && formattedText.indexOf(ChartConst.noneTooltip) === -1
          ? d.tooltip.unit
          : ''
      } `;
    }
    if (
      (d.key === ChartConst.ChartLabelSpecs.cig.key && dMain[key] === 12000)
      || (dMain[key]
        && d.key === ChartConst.ChartLabelSpecs.cig.key
        && dMain.cld
        && dMain.cld !== DefConst.clouds.broken
        && dMain.cld !== DefConst.clouds.overcast
        && dMain.cld !== DefConst.clouds.ovx)
    ) {
      formattedText = `${d.tooltip.prefix}: ${ChartConst.unlimitedTooltip}`;
    }

    return utilityService.styleTooltip(formattedText);
  }

  function processValuesForTooltip(d) {
    d.tooltipValue = d.cig_mapped;
    if (settingsObj.temperatureUnit === AppConst.temperatureUnits.fahrenheit.key) {
      d.tmp_display_value = d.tmp_fahrenheit;
    } else {
      d.tmp_display_value = d.tmp_celsius;
    }
    d.wsp = bnChartDataProcessService.parseYValueInterface(d.wsp);
    d.wdr = bnChartDataProcessService.parseYValueInterface(d.wdr) || 0;
    d.wgs = bnChartDataProcessService.parseYValueInterface(d.wgs) || null;
    d.xwd = bnChartDataProcessService.parseYValueInterface(d.xwd);

    d.p06 = bnChartDataProcessService.parseYValueInterface(d.p06);
    d.q06_mapped = bnChartDataProcessService.parseYValueInterface(d.q06_mapped);
    d.t06 = bnChartDataProcessService.parseYValueInterface(d.t06);
    d.st6 = bnChartDataProcessService.parseYValueInterface(d.st6);
    d.ppo = bnChartDataProcessService.parseYValueInterface(d.ppo);
    d.t01 = bnChartDataProcessService.parseYValueInterface(d.t01);
    d.sno = bnChartDataProcessService.parseYValueInterface(d.sno);
    d.fzp = bnChartDataProcessService.parseYValueInterface(d.fzp);
    d.rlh = bnChartDataProcessService.parseYValueInterface(d.rlh);
    d.tmp_display_value = bnChartDataProcessService.parseYValueInterface(d.tmp_display_value);
  }
  content.getPopoverHtml = function (d, settings, appendBubble, appendTop) {
    const nmFormat = d3.format('.0f');
    if (settings) {
      settingsObj = settings;
      setDateFormat();
    }
    if (settings && !dateFormat) {
      setDateFormat();
    }
    let html = '';
    if (appendBubble && appendTop) {
      html += "<div id='gridtipbubble' class='d3-grid-bubble'></div>";
    }
    html += `<div id='conditiontooltip' class='conditions ${
      d.cld === DefConst.ovxMetar ? 'obscured' : ''
    } card'>`;
    // MOS tooltip
    // html += "<a href='#close' class='leaflet-close'><i  class='icon ion-close-circled'></i></a>";
    html += `<div class='airport'><b>${d.icao_id}</b> ${d.faa_facility_name || ''}</div>`;
    html += "<div class='card-left'>";
    if (d.isMetarObj) {
      if (d.observation_time_local) {
        html += `<div class='airport'>${ChartConst.metarValidTooltipPrefix}${
          d.observation_time_local ? dateFormat(d.observation_time_local) : 'Data not available'
        }</div>`;
      } else {
        html += "<div class='airport'>Data not available</div>";
      }
    } else {
      html += `<div class='airport'>${ChartConst.mosValidTooltipPrefix}${
        d.forecast_ts_local ? dateFormat(d.forecast_ts_local) : '--'
      }</div>`;
    }
    if (d.elapsed_nm) {
      html += `<div class='airport'>${nmFormat(d.elapsed_nm)}nm` + '</div>';
    }
    const colorValue = bnd3Service.getFlightDotColor(d.frl);
    html += `<div class='weather-flight-img backlight${colorValue.replace(
      '#',
      '',
    )}' style='background-color:${colorValue}'>`;
    if (d.weatherRepresentation) {
      html += `<img class='condition-icon' src='${utilityService.getWeatherFilePath(
        d.weatherRepresentation.filename,
        utilityService.useWhiteImage(colorValue),
      )}' />`;
    }
    html += `<p>${bnd3Service.getFlightDotText(d.frl) || '--'}${
      d.cld ? `, ${utilityService.getCloudText(d.cld)}` : ', ' + '--'
    }</p></div>`;
    html += '</div>';
    html += "<div class='card-right'>";
    processValuesForTooltip(d);
    if (!d.isMetarObj || utilityService.isValueValid(d.cig_mapped)) {
      html += `<div>${getFormatText(d, 'cig_mapped', 'cig')}</div>`;
    }
    if (d.isMetarObj && d.vis_display) {
      html += `<div>${getFormatText(d, 'vis_display', 'vis')}</div>`;
    } else if (!d.isMetarObj) {
      html += `<div>${getFormatText(d, 'vis_mapped', 'vis')}</div>`;
    }
    // Wind data
    if (utilityService.isValueValid(d.wsp)) {
      html += `<div>${getFormatText(d, 'wsp')}</div>`;
    }
    if (utilityService.isValueValid(d.xwd)) {
      html += `<div>${getFormatText(d, 'xwd')}</div>`;
    }
    if (utilityService.isValueValid(d.wgs)) {
      html += `<div>${getFormatText(d, 'wgs')}</div>`;
    }
    // Precip Data
    if (d.p06) {
      html += `<div>${getFormatText(d, 'p06')}</div>`;
    }
    // if (d.q06) {
    // hide q06 from tooltip as well
    //     // html += "<div>" + getFormatText(d, "q06_mapped", "q06") + "</div>";
    // }
    if (d.t06) {
      html += `<div>${getFormatText(d, 't06')}</div>`;
    }
    if (d.st6) {
      html += `<div>${getFormatText(d, 'st6')}</div>`;
    }
    if (d.ppo) {
      html += `<div>${getFormatText(d, 'ppo')}</div>`;
    }
    if (d.t01) {
      html += `<div>${getFormatText(d, 't01')}</div>`;
    }
    if (d.sno && d.sno > ChartConst.precipNoneValuePlaceHolder) {
      // Don't show sno and fzp at all if none i.e. 0
      html += `<div>${getFormatText(d, 'sno')}</div>`;
    }
    if (d.fzp && d.fzp > ChartConst.precipNoneValuePlaceHolder) {
      // Don't show sno and fzp at all if none i.e. 0
      html += `<div>${getFormatText(d, 'fzp')}</div>`;
    }

    if (utilityService.isValueValid(d.alt)) {
      html += `<div>${getFormatText(d, 'alt')}</div>`;
    }

    if (d.isMetarObj) {
      if (settingsObj.temperatureUnit === AppConst.temperatureUnits.fahrenheit.key) {
        d.tmp_display_value = d.tmp_fahrenheit;
        d.dew_display_value = d.dew_fahrenheit;
      } else {
        d.tmp_display_value = d.tmp_celsius;
        d.dew_display_value = d.dew_celsius;
      }
    }
    // Temp Data
    if (utilityService.isValueValid(d.tmp_display_value)) {
      html += `<div>${getFormatText(d, 'tmp_display_value', 'tmp')}</div>`;
    }
    if (utilityService.isValueValid(d.dew_display_value)) {
      html += `<div>${getFormatText(d, 'dew_display_value', 'dew')}</div>`;
    }
    if (utilityService.isValueValid(d.rlh)) {
      html += `<div>${getFormatText(d, 'rlh')}</div>`;
    }
    html += '<div>';
    html += '</div>';
    html += '</div>';
    if (d.isMetarObj && d.raw_text) {
      html += "<div class='metar-cont-raw'>";
      html += d.raw_text;
      html += '</div>';
    }
    html += '</div>';
    if (appendBubble && !appendTop) {
      html += "<div id='gridtipbubble' class='d3-grid-bubble'></div>";
    }
    return html;
  };

  return content;
}

export default mapLeafService();
